<template>
  <mt-popup class="popup"
    v-model="popupVisible"
    popup-transition="popup-fade"
    :closeOnClickModal="false">
    <img class="qrcode" :src="src" alt="">
    <img class="background" :src="background" alt="">
    <p class="no-result-title">{{title}}</p>
    <p class="no-result-content">{{content}}</p>
    <div class="operation-wrap" v-if="text">
      <el-button type="text" @click="monitorEvent">{{text}}</el-button>
    </div>
    <span class="iconfont icon--close close" @click="closePopup"></span>
  </mt-popup>
</template>
<script>
export default {
  props: {
    src: String,
    title: String,
    content: String,
    text: String,
    popupVisible: Boolean,
    background: String
  },
  methods: {
    monitorEvent () {
      this.$emit('monitorEvent')
    },
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/MobilePopup/index.vue